import { render, staticRenderFns } from "./QuestionQCM.vue?vue&type=template&id=83fd046e&scoped=true&"
import script from "./QuestionQCM.vue?vue&type=script&lang=js&"
export * from "./QuestionQCM.vue?vue&type=script&lang=js&"
import style0 from "./QuestionQCM.vue?vue&type=style&index=0&id=83fd046e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fd046e",
  null
  
)

export default component.exports